import { useAppDispatch } from "store";

import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { toggleCertificateModal } from "features";

const CertificateRedirectPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { certificateGuid, pin } = useParams<{ certificateGuid: string; pin: string }>();

  useEffect(() => {
    if (certificateGuid && pin) {
      dispatch(toggleCertificateModal({ isOpen: true, certificateGuid, pin }));
    }
    navigate("/", { replace: true });
  }, [certificateGuid, pin, dispatch, navigate]);

  return <></>;
};

export default CertificateRedirectPage;
